export const px = (value: number): string => `${value}px`;
export const border = (thickness: number, color: string, style = 'solid'): string => `${thickness}px ${style} ${color}`;
